var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-js vjs-16-9 vjs-big-play-centered",staticStyle:{"width":"100%"}},[_c('video',{ref:"VideoJsPlayer",staticClass:"vjs-default-skin",staticStyle:{"position":"absolute","top":"0","left":"0","width":"100%","height":"100%"},attrs:{"id":"custom-rtmp-player","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }